"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _react = _interopRequireDefault(require("react"));
var _commonI18n = require("@mmc/common-i18n");
var _text = require("@mmc/text");
var _homepageCarSelector = _interopRequireDefault(require("../styles/homepage-car-selector.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;

/**
 * ## Inner Card - component
 *
 * This is the card portion of the two-part car selector. It will be fed into the carousel component.
 */
var InnerCard = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function InnerCard() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(InnerCard, _React$Component);
  var _proto = InnerCard.prototype;
  _proto.renderLabel = function renderLabel() {
    var _this$props = this.props,
      oneTile = _this$props.oneTile,
      theme = _this$props.theme,
      isLabel = _this$props.isLabel,
      selectedLabel = _this$props.selectedLabel;
    if (isLabel === true) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _homepageCarSelector["default"].tagContainer + " " + _homepageCarSelector["default"].radioLabel
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _homepageCarSelector["default"].tagLabel + " " + theme.tags
      }, selectedLabel));
    }
    if (oneTile.tag && oneTile.tag.label) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _homepageCarSelector["default"].tagContainer
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _homepageCarSelector["default"].tagLabel + " " + theme.tags
      }, handleNestedProp(oneTile, 'oneTile.tag.label')));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].noTagSpacer
    });
  };
  _proto.renderDummyPrice = function renderDummyPrice() {
    var market = this.props.config.market;
    return market === 'language-masters' ? 'From $XX,XXX.XX' : '';
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      oneTile = _this$props2.oneTile,
      theme = _this$props2.theme,
      config = _this$props2.config,
      isLabel = _this$props2.isLabel,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData,
      enableBackgroundImage = _this$props2.enableBackgroundImage;
    var vehicleImage = handleNestedProp(oneTile, 'oneTile.vehicleImage.image');
    var imageStyle = {
      backgroundImage: appendImageTransforms(handleNestedProp(oneTile, 'oneTile.vehicleBackgroundImage.image'), 480, true)
    };
    var hasBackgroundImage = enableBackgroundImage !== false && oneTile.vehicleBackgroundImage;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].cardContainer + " " + (hasBackgroundImage ? _homepageCarSelector["default"].hasBackgroundImage : '')
    }, hasBackgroundImage && /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].vehicleBackgroundImageContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].vehicleBackgroundImage,
      style: isLabel !== true ? imageStyle : {}
    })), this.renderLabel(), /*#__PURE__*/_react["default"].createElement("img", {
      className: _homepageCarSelector["default"].vehicleImage,
      src: appendImageTransforms(vehicleImage, 720) + "&auto=webp",
      srcSet: appendImageTransforms(vehicleImage, 320) + "&auto=webp 320w, " + appendImageTransforms(vehicleImage, 480) + "&auto=webp 480w, " + appendImageTransforms(vehicleImage, 720) + "&auto=webp 720w, " + appendImageTransforms(vehicleImage, 1080) + "&auto=webp 1080w, " + appendImageTransforms(vehicleImage, 1440) + "&auto=webp 1440w, " + appendImageTransforms(vehicleImage, 2160) + "&auto=webp 2160w",
      sizes: "(min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw",
      alt: handleNestedProp(oneTile, 'oneTile.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("h3", {
      className: _homepageCarSelector["default"].name + " " + theme.headingFive
    }, handleNestedProp(oneTile, 'oneTile.name')), oneTile.enableProductsRatingStars && /*#__PURE__*/_react["default"].createElement("div", {
      className: "feefo-product-stars-widget",
      "data-product-sku": handleNestedProp(oneTile, 'oneTile.productSkuId')
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _homepageCarSelector["default"].price + " " + theme.bodyCopy
    }, oneTile.price && oneTile.price.value !== null ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: handleNestedProp(oneTile, 'oneTile.price.value'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode'),
        displayValue: handleNestedProp(oneTile, 'oneTile.price.displayValue'),
        zeroMessage: handleNestedProp(oneTile, 'oneTile.price.zeroMessage')
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    }) : this.renderDummyPrice()));
  };
  return InnerCard;
}(_react["default"].Component);